import api from "./api";

export const upload = async (data,id) => {
  return await api.put(`/card/update/${id}`,data);
};

export const saveCard = async (data) => {
  return await api.post("/card/save", data);
};

export const scanCard = async (data) => {
  return await api.post("/card/scan", data);
};

// Backward-compatible alias for callers that still use the old function name.
export const cardUpload = scanCard;
